import React, { useState, useReducer, useEffect } from 'react';
import { PropTypes } from 'prop-types';

import GallerySave from './GallerySave';
import GalleryCreate from './GalleryCreate';
import getMamObjectsBySlugname from '../../api/graphql/queries/getMamObjectsBySlugname';
import slugify from '../../utils/slugify';
import checkPostSlugNameRepeated from '../../utils/checkPostSlugNameRepeated';

import postAddPost from '../../api/graphql/mutations/postAddPost';
import postEditPost from '../../api/graphql/mutations/postEditPost';

const postInitialState = {
  slugName: '',
  postName: '',
  postCategory: [],
  type: 'component',
  active: false,
  postDescription: {
    date: new Date(),
  },
};

// Depending of where this is being called the type of this comp can be Gallery or CarouselWithDescription

const initialState = {
  type: 'Gallery',
  showFilter: false,
  showSearchBar: false,
  filterText: {
    en: '',
    es: '',
    ca: '',
    pt: '',
  },
  name: '',
  title: {
    en: '',
    es: '',
    ca: '',
    pt: '',
  },
  description: {
    en: '',
    es: '',
    ca: '',
    pt: '',
  },
  tags: [],
  objects: [],
  images: [],
  hideDownloadButton: false,
};

const GalleryContainer = ({
  selectCallback, getGalleryData, isCarousel, toggleRefetch, type,
}) => {
  const [selectedObjects, setSelectedObjects] = useState([]);
  const [galleryData, setGalleryData] = useState();
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState();

  const setObjects = (obj) => {
    if (selectedObjects.length === 0) {
      setSelectedObjects([...selectedObjects, obj]);
    } else if (selectedObjects.some(item => item.assetSlugName === obj.assetSlugName)) {
      const index = selectedObjects.findIndex(selObj => selObj.assetSlugName === obj.assetSlugName);
      selectedObjects.splice(index, 1);
      setSelectedObjects([...selectedObjects]);
    } else {
      setSelectedObjects([...selectedObjects, obj]);
    }
  };

  const sendGallery = async () => {
    const slugName = slugify(galleryData.name);

    if (slugName !== '') {
      if (getGalleryData.name !== galleryData.name || !getGalleryData) {
        const slugNameRepeated = await checkPostSlugNameRepeated(slugName);

        if (slugNameRepeated) return setError('Title already taken, try another.');
      }

      let selectObjectSlugNames = [];

      if (selectedObjects.length > 0) {
        selectedObjects.forEach(obj => selectObjectSlugNames.push(obj.assetSlugName));
      } else {
        selectObjectSlugNames = [];
      }

      let selectedObjectUrls = [];

      if (selectedObjects.length > 0 && isCarousel) {
        selectedObjects.forEach(obj => selectedObjectUrls.push(obj.url));
      } else {
        selectedObjectUrls = [];
      }

      if (isCarousel) galleryData.type = 'CarouselWithDescription';
      postInitialState.name = galleryData.title.en;
      postInitialState.slugName = slugName;

      const componentData = {
        ...galleryData,
        objects: selectObjectSlugNames,
        images: selectedObjectUrls,
      };

      const arrayImagesObj = componentData.objects;
      postInitialState.components = JSON.stringify(componentData);

      if (postInitialState) {
        if (selectCallback) {
          selectCallback(postInitialState.slugName, arrayImagesObj, true, galleryData);
        }
        if (getGalleryData && galleryData && galleryData.name === getGalleryData.name) {
          console.log('this will edit a post', postInitialState);
          postEditPost(postInitialState)
            .then(({ isEdited }) => {
              if (!isEdited) {
                console.error('Gallery not created');
              } else {
                console.log('Gallery created');
                // toggleRefetch();
              }
            })
            .catch(err => console.log(err));
        } else {
          postAddPost(postInitialState)
            .then(({ isAdded }) => {
              if (!isAdded) {
                console.error('Gallery not created');
              } else {
                console.log('Gallery created');
                // toggleRefetch();
              }
            })
            .catch(err => console.log(err));
        }
      }
    } else {
      setError('You need to add a Title first.');
    }
  };

  useEffect(() => {
    setGalleryData(initialState);
  }, []);

  useEffect(() => {
    if (Object.entries(getGalleryData).length !== 0) {
      setGalleryData(getGalleryData);
      getMamObjectsBySlugname(getGalleryData.objects)
        .then((res) => {
          setSelectedObjects(res);
        })
        .catch(err => console.log(err));
    }
  }, [getGalleryData]);

  const inputObjectHandler = (e) => {
    setError();
    const { name, value, lang } = e.target;

    const component = {
      ...galleryData,
      [name]: {
        ...galleryData[name],
        [lang]: value,
      },
    };

    setGalleryData(component);
  };

  const inputHandler = (e) => {
    setError();
    const { name, value } = e.target;

    const comp = {
      ...galleryData,
      [name]: value,
    };

    setGalleryData(comp);
  };

  const handleTags = (name) => {
    const index = galleryData.tags.indexOf(name);
    const { tags } = galleryData;
    if (index < 0) {
      tags.push(name);
    } else {
      tags.splice(index, 1);
    }
    const data = {
      ...galleryData,
      tags,
    };
    setGalleryData(data);
  };

  return (
    <>
      {error && <p className="text-xs font-americaMonoRegular uppercase">{error}</p>}
      {!showForm ? (
        <GalleryCreate selectedObjects={selectedObjects} setObjects={setObjects} showForm={showForm} type={type} setShowForm={setShowForm} />
      ) : (
        <GallerySave galleryData={galleryData} selectedObjects={selectedObjects} showForm={showForm} setShowForm={setShowForm} inputHandler={inputHandler} inputObjectHandler={inputObjectHandler} sendGallery={sendGallery} toggleTag={handleTags} />
      )}
    </>
  );
};

GalleryContainer.propTypes = {
  selectCallback: PropTypes.func,
  toggleRefetch: PropTypes.func.isRequired,
  getGalleryData: PropTypes.shape(),
  isCarousel: PropTypes.bool,
};

GalleryContainer.defaultProps = {
  selectCallback: null,
  getGalleryData: {},
  isCarousel: false,
};

export default GalleryContainer;
